import type { AboutCopy } from '../types/about';

export const aboutIt: AboutCopy = {
  seo: {
    title: 'Chi siamo',
    description:
      'SafestMenu è realizzato e gestito da transfactor.dev, un team di sviluppo software senior a Bucarest, Romania - certificato ISO 9001 e ISO/IEC 27001.',
  },
  hero: {
    eyebrow: 'Chi siamo',
    heading:
      'Realizzato da persone che sviluppano software per mestiere - e mangiano fuori spesso.',
  },
  story: {
    intro:
      'SafestMenu nasce da un’osservazione semplice: i menu di carta costano cari da ristampare, sono impossibili da tenere aggiornati, passano per le mani di centinaia di clienti e finiscono nel cestino a pile. Ogni ristorante con cui abbiamo parlato aveva lo stesso problema - e nessun tempo per una soluzione complicata.',
    easyIntro:
      'Così abbiamo creato il menu che avremmo voluto nel nostro ristorante: uno che configuri in pochi minuti, aggiorni dal telefono e non stampi mai più. ',
    easyHighlight: 'Facile da usare',
    easyOutro: ' non era una voce nell’elenco delle funzioni - era il punto centrale.',
    imageAlt: 'Un cartoncino da tavolo con codice QR SafestMenu su un tavolo di caffè accanto a un espresso',
  },
  team: {
    heading: 'Il team dietro SafestMenu',
    linkIntro: 'SafestMenu è realizzato e gestito da ',
    linkText: 'transfactor.dev',
    linkOutro:
      ', un team di sviluppo software senior con sede a Bucarest, Romania. transfactor.dev progetta, sviluppa e mette in produzione prodotti web, sistemi di IA e strumenti interni - oltre venti prodotti rilasciati e diciotto anni di esperienza complessiva, con certificazione ISO 9001 e ISO/IEC 27001.',
    reliability:
      'Per te questo conta in un modo concreto: SafestMenu non è un progetto collaterale che sparisce l’anno prossimo. Viene mantenuto, protetto e migliorato dallo stesso team, ogni settimana.',
  },
  beliefs: {
    heading: 'In cosa crediamo',
    items: [
      'Il software per i ristoranti dovrebbe essere più semplice che gestire un ristorante.',
      'I clienti meritano menu onesti: prezzi chiari, foto vere, allergeni segnati.',
      'Meno carta nel cestino fa bene a tutti - anche al tuo portafoglio.',
    ],
  },
  cta: {
    label: 'Prova SafestMenu gratis',
  },
};
